const initialState = {};

const Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "SAVE_DashboardOverview":
      return { ...state, Overview: payload };
    case "SAVE_DashboardOverdueTasks":
      return { ...state, OverdueTasks: payload };
    case "SAVE_DashboardMyTasks":
      return { ...state, MyTasks: payload };
    case "SAVE_DashboardActivities":
      return { ...state, Activities: payload };
    case "SAVE_DashboardProjectOverview":
      return { ...state, ProjectOverview: payload };
    case "CLEAR":
      return initialState;
    default:
      return state;
  }
};

export default Reducer;
